import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { DataTable } from "@/components/ui/data-table";
import { useDataTable } from "@/hooks/use-data-table";
import type { OfferObject } from "@/libs/generated/types";

import { offerColumns } from "./columns";

type OffersTableProps = {
  data: OfferObject[];
  isLoading?: boolean;
  emptyMessage?: string;
};

export function OffersTable({
  data,
  isLoading = false,
  emptyMessage = "Aucune offre n'a été soumise.",
}: OffersTableProps) {
  const columns = useMemo(() => offerColumns, []);
  const { table } = useDataTable<OfferObject>({
    data,
    columns,
    pageCount: -1,
  });

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!isLoading && data.length === 0) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <Typography>{emptyMessage}</Typography>
      </Box>
    );
  }

  return <DataTable table={table} totalCount={data.length} isLoading={isLoading} />;
}
